import * as icons from 'core/icons';

const gestion = {
    id: 'gestion',
    title: 'Gestión',
    type: 'group',
    collapse: false,
    visible: true,
    children: [
        {
            id: 'ventas',
            title: 'Ventas',
            type: 'collapse',
            visible: true,
            icon: icons.FacturacionIcon,
            children: [
                {
                    id: 'presupuestos',
                    title: 'Presupuestos',
                    type: 'item',
                    visible: false,
                    url: '/gestion/facturacion/presupuestos',
                    icon: icons.PresupuestoContableIcon,
                    breadcrumbs: false
                },
                {
                    id: 'facturas',
                    title: 'Facturas',
                    type: 'item',
                    visible: true,
                    url: '/gestion/facturacion/facturas',
                    icon: icons.FacturasIcon,
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'inventario',
            title: 'Inventario',
            type: 'item',
            url: '/gestion/inventario',
            visible: false,
            icon: icons.InventarioIcon,
            breadcrumbs: false
        }
    ]
};

export default gestion;
